import {
  CardItemTypes,
  IAudioCardItem,
  ICheckListCardItem,
  IGifCardItem,
  IImageCardItem,
  ILinkCardItem,
  IMultipleChoiceCardItem,
  IOpenQuestionCardItem,
  IPollCardItem,
  ITextCardItem,
  IVideoCardItem,
  TCardItem,
} from 'types/card';

interface IGraphQlType {
  __typename?: string;
}

export const isOfType = <T extends IGraphQlType>(
  varToBeChecked: any,
  typename: string,
): varToBeChecked is T => (varToBeChecked as T)?.__typename === typename;

export const isPollCardItem = (item: TCardItem): item is IPollCardItem =>
  item.meta.type === CardItemTypes.POLL;

export const isMultipleChoiceCardItem = (
  item: TCardItem,
): item is IMultipleChoiceCardItem =>
  item.meta.type === CardItemTypes.MULTIPLE_CHOICE_QUESTION;

export const isCheckListCardItem = (
  item: TCardItem,
): item is ICheckListCardItem => item.meta.type === CardItemTypes.CHECK_LIST;

export const isOpenQuestionCardItem = (
  item: TCardItem,
): item is IOpenQuestionCardItem =>
  item.meta.type === CardItemTypes.OPEN_QUESTION;

export const isAudioCardItem = (item: TCardItem): item is IAudioCardItem =>
  item.meta.type === CardItemTypes.AUDIO;

export const isImageCardItem = (item: TCardItem): item is IImageCardItem =>
  item.meta.type === CardItemTypes.IMAGE;

export const isGifCardItem = (item: TCardItem): item is IGifCardItem =>
  item.meta.type === CardItemTypes.GIF;

export const isVideoCardItem = (item: TCardItem): item is IVideoCardItem =>
  item.meta.type === CardItemTypes.VIDEO;

export const isLinkCardItem = (item: TCardItem): item is ILinkCardItem =>
  item.meta.type === CardItemTypes.LINK;

export const isTextCardItem = (item: TCardItem): item is ITextCardItem =>
  [
    CardItemTypes.TEXT,
    CardItemTypes.STORY_TITLE,
    CardItemTypes.STORY_DESCRIPTION,
  ].includes(item.meta.type);
